// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SystemUpdate: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 46 38" enableBackground="new 0 0 46 38" xmlSpace="preserve">
<g>
	<polygon points="23,27.38 31.33,19.04 25.08,19.04 25.08,0.29 20.92,0.29 20.92,19.04 14.67,19.04 	"/>
	<path d="M41.75,0.29h-12.5v4.15h12.5v29.23H4.25V4.44h12.5V0.29H4.25c-2.29,0-4.17,1.88-4.17,4.17v29.17
		c0,2.29,1.88,4.17,4.17,4.17h37.5c2.29,0,4.17-1.88,4.17-4.17V4.46C45.92,2.17,44.04,0.29,41.75,0.29z"/>
</g>
</svg>;
};

export default React.memo(SystemUpdate);
